
// noop directive only for styling
export default {

}